export default __webpack_public_path__ + "static/media/SFUIDisplay-Semibold.43c109ed.ttf";